<template>
  <a-layout-sider v-model="collapsed" class="sider" :trigger="null" collapsible width="220">
    <div class="logo" v-if="!collapsed">
      <router-link :to="'/home'">
        <img src="@assets/img/logo.png" alt="logo.png" />
      </router-link>
    </div>

    <div class="logo-text" v-if="collapsed">
      <router-link :to="'/home'">
        <img src="@assets/img/logo-small.png" alt="logo-small.png" />
      </router-link>
    </div>

    <a-menu theme="dark" class="menu-content" mode="inline" :selectedKeys="[currentPath]" @click="handleChangeMenu($event)">
      <template v-for="item in MENU">
        <a-menu-item :key="item.path" class="menu-item" v-if="!item.children && (!item.showWhenFeatureEnabled || featureAccess[item.showWhenFeatureEnabled])">
            <template v-if="item.isUnavailable">
              <div class="full-wh disabled-text" @click.prevent="unavailablePath">
                <img class="anticon" src="@assets/icon/menu-item.svg" alt="logo.png" />
                <span>{{ item.name }}</span>
              </div>
            </template>
            <template v-if="!item.isUnavailable">
              <router-link :to="item.path">
                <img class="anticon" src="@assets/icon/menu-item.svg" alt="logo.png" />
                <span>{{ item.name }}</span>
              </router-link>
            </template>
        </a-menu-item>

        <a-sub-menu
          v-if="
            item.children
            && isFeatureVisible(item)
            && visibleSubmenuChildren(item.children).length
          "
          :key="item.path"
        >
          <span slot="title">
            <img class="anticon" src="@assets/icon/menu-item.svg" alt="logo.png" />
            <span>{{ item.name }}</span>
            <a-tag
              v-if="item.path === '/admin'"
              color="orange"
              class="menu-staff-tag"
            >
              staff
            </a-tag>
          </span>
          <a-menu-item v-for="child in visibleSubmenuChildren(item.children)" :key="child.path">
            <template v-if="child.isUnavailable">
              <div class="full-wh disabled-text" @click.prevent="unavailablePath">
                {{ child.name }}
              </div>
            </template>
            <template v-if="!child.isUnavailable">
              <router-link :to="child.path">
                {{ child.name }}
              </router-link>
            </template>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
  import { MENU } from '@constants/menu.const';

  export default {
    name: 'Sider',
    props: {
      collapsed: Boolean,
    },
    data() {
      return {
        MENU,
        currentPath: this.$router.history.current.path,
      };
    },
    watch: {
      $route: function (route) {
        const { fullPath, meta } = route;
        if (this.currentPath !== fullPath) {
          this.currentPath = fullPath;
        }
        document.title = `WebOrion Defacement Monitor ` + (meta && meta.title ? ` - ${meta.title}` : '');
      },
    },
    methods: {
      isFeatureVisible(item) {
        return Boolean(
          !item.showWhenFeatureEnabled
          || this.featureAccess[item.showWhenFeatureEnabled]
        );
      },
      visibleSubmenuChildren(children) {
        if (!children || !children.length) {
          return [];
        }
        const fa = this.featureAccess || {};
        return children.filter(
          (c) => !c.showWhenFeatureEnabled || Boolean(fa[c.showWhenFeatureEnabled])
        );
      },
      handleChangeMenu(e) {
        this.currentPath = e.key;
      },
      unavailablePath() {
        this.$showInfoMessage('This feature is coming soon');
      },
    },
    computed: {
      featureAccess() {
        return (this.$store.state.user.data && this.$store.state.user.data.feature_access) || {};
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo {
    height: 30px;
    width: 165px;
    margin: 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .logo-text {
    color: #ffffff;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }

  #private-layout .sider {
    background: $prDrk;
  }

  #private-layout .menu-content {
    background: $prDrk;
    color: $prLgt;
    border-right: 0px;
  }

  #private-layout .menu-item {
    border-radius: 5px;
  }

  .mr-32 {
    margin-right: 32px;
  }
  .menu-content {
    overflow-y: auto;
    height: calc(100% - 70px);
    direction: rtl;
    & > * {
      text-align: inherit;
      direction: ltr;
    }
  }
  .disabled-text {
    color: $primary-light;
  }

  .menu-staff-tag {
    margin-left: 8px;
    font-size: 11px;
    line-height: 16px;
    height: 18px;
    padding: 0 5px;
    border: 0;
    vertical-align: middle;
  }
</style>
